import { useCallback } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';

import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

import { MODAL_NAMES } from '#client/constants/modals';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';
import useModalContext from '#client/hooks/useModalContext';

export default function CardButton() {
  const { isDisable } = useDisableDashboardContext();
  const { openModal } = useModalContext();

  const trackCardsBtnPressed = useButtonPressedCallback({
    elementName: 'manage_cards_button',
    elementText: 'Cards',
    appPageName: 'active_banking_dashboard'
  });

  const handleOpenAddCardModal = useCallback(() => {
    trackCardsBtnPressed();
    openModal({
      name: MODAL_NAMES.CARD_MODAL
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  return (
    <Button
      disabled={isDisable}
      icon={<CreditCardOutlinedIcon />}
      onClick={handleOpenAddCardModal}
      size="small"
      variant="outlined"
    >
      Cards
    </Button>
  );
}
